import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  
  // Map route paths to display names
  const breadcrumbMap = {
    'dashboard': 'Dashboard',
    'strategies': 'Strategies',
    'create-strategies': 'Create Strategy',
    'AboutStrategies': 'Strategy Details',
    'aboutStrategy': 'Strategy Details',
    'strategies-details': 'Strategy Details',
    'profile': 'Profile',
    'marketplace': 'Marketplace',
    'contact': 'Contact',
    'help': 'Help',
    'subscribe': 'Subscribe',
    'result': 'Results',
    'analytics': 'Analytics'
  };
  
  // Don't show breadcrumb on login page
  if (pathnames.length === 0) {
    return null;
  }
  
  return (
    <nav className="breadcrumb-nav" aria-label="breadcrumb">
      <div className="breadcrumb-container">
        <Link to="/dashboard" className="breadcrumb-item">
          <span>Home</span>
        </Link>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const displayName = breadcrumbMap[name] || name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, ' ');
          
          return (
            <React.Fragment key={name}>
              <span className="breadcrumb-separator">
                <FaChevronRight />
              </span>
              {isLast ? (
                <span className="breadcrumb-item active" aria-current="page">
                  {displayName}
                </span>
              ) : (
                <Link to={routeTo} className="breadcrumb-item">
                  {displayName}
                </Link>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </nav>
  );
};

export default Breadcrumb;
